import { CampaignResponse } from 'jsonutils/reports';
import { AdvertisementResponse } from 'jsonutils/reports';

export const GET_CAMPAIGN_REPORT_LIST = 'GET_CAMPAIGN_REPORT_LIST';

export interface GetCampaignReportAction {
	type: typeof GET_CAMPAIGN_REPORT_LIST;
	payload: any;
}
export const UPDATE_CAMPAIGN_REPORTS = 'UPDATE_CAMPAIGN_REPORTS';

export interface UpdateCampaignReportsAction {
	type: typeof UPDATE_CAMPAIGN_REPORTS;
	payload: Partial<CampaignResponse>;
}

export const GET_ADVERTISEMENT_REPORT_LIST = 'GET_ADVERTISEMENT_REPORT_LIST';

export interface GetAdvertisementReportAction {
	type: typeof GET_ADVERTISEMENT_REPORT_LIST;
	payload: any;
}

export const UPDATE_ADVERTISEMENT_REPORTS = 'UPDATE_ADVERTISEMENT_REPORTS';
export interface UpdateAdvertisementReportsAction {
	type: typeof UPDATE_ADVERTISEMENT_REPORTS;
	payload: Partial<AdvertisementResponse>;
}
export const GET_VIEWERSHIP_REPORT_LIST = 'GET_VIEWERSHIP_REPORT_LIST';

export interface GetViewershipReportAction {
	type: typeof GET_VIEWERSHIP_REPORT_LIST;
	payload: any;
}
export const RESET_CLIENT_REPORTS = 'RESET_CLIENT_REPORTS';
export interface ResetClientReportsAction {
	type: typeof RESET_CLIENT_REPORTS;
	payload: any;
}


export type ClientReportsAction =
	| GetCampaignReportAction
	| UpdateCampaignReportsAction
	| GetAdvertisementReportAction
	| GetViewershipReportAction
	| ResetClientReportsAction
	| UpdateAdvertisementReportsAction;
